const tintColorLight = '#2f95dc';
const tintColorDark = '#fff';

export const black = '#000000';
export const green = '#00291b';
export const sand = '#f7f5e8';
export const accent = '#ded943';
export const alternateBorder = '#ada993';
export const borderColor = '#cacaca';
export const white = '#ffffff';
export const offWhite = '#fdfbf8';
export const mint = '#e4e8d1';
export const mintGreen = '#c7d1b8';
export const mintGreenAlt = '#c7d7d1';
export const lightGreen = '#5e6f69';
export const lightGreenAlt = '#9AB290';
export const darkGreen = '#001E14';
export const darkGreenAlt = '#00291B';
export const mutedGreen = '#667f76';
export const placeholder = '#819991';
export const red = '#e93633';
export const cancelledRed = '#bc3d31';
export const subheadline = '#475f57';
export const lightGrey = '#ededed';
export const lightGreyAlt = '#f8f8f8';
export const pillBrown = '#e0ddcb';

export const primaryHover = '#37574C';
export const secondaryHover = '#D2CDB4';

export const disabledLightestGrey = '#e9e9e9';
export const disabledLightGrey = '#D6D6D6';
export const disabledDarkestGrey = '#8A8A8A';
export const disabledDarkGrey = '#9eaba6';
export const disabledGrey = '#b6bdb0';
export const disabledGreen = '#4f6d64';

export const buttonShadow = '#3736362d';
export const selectButtonShadow = '#00000033';
export const bottomBarShadow = '#0000002b';
export const tabsBarShadow = '#939186ef';
export const progressBarBackground = '#F4F1EB';

export const checklistBackground = '#023523';
export const testimonialCardBackground = '#023624';
export const calendarBackground = '#fafbf4';

export const alphaBlack05 = 'rgba(0, 0, 0, 0.05)';
export const alphaBlack03 = 'rgba(0, 0, 0, 0.03)';
export const alphaBlack50 = 'rgba(0, 0, 0, 0.5)';

export const videoCellBackground = '#e5e8e7';

export const welcomeKeepInTouchBackground = '#E8EDE0';
export const welcomeKeepInTouchText = '#2E4733';

export const welcomeMutedOnGreen = '#d5e2de';

export default {
  light: {
    text: '#000',
    background: '#fff',
    tint: tintColorLight,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: '#fff',
    background: '#000',
    tint: tintColorDark,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorDark,
  },
};
